export default "__VITE_ASSET__CX6L2I40__"